import { useFormActions } from "@ngt/forms-core";
import { FC, PropsWithChildren, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface IFormValidationTranslationProviderProps extends PropsWithChildren {

}

const FormValidationTranslationProvider: FC<IFormValidationTranslationProviderProps> = ({
    children
}) => {
    const { validate } = useFormActions();

    const { t } = useTranslation();

    useEffect(() => {
        const timeout = window.setTimeout(() => {
            if(validate) {
                validate()
            }
        }, 0);

        return () => window.clearTimeout(timeout);
    }, [validate, t]);

    return (
        <>{children}</>
    )
}

export default FormValidationTranslationProvider;